import src from "IMAGE";
export default { src, width: 458, height: 87, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42hXIsQkAIRBEUbPFZVa4Nu6quMRcBBXEQPsvwtng8YcJyexojD87aTtVzQY07hVE5KPX8ew0ABTvk1Av5qAHCDkZo6IAAAAASUVORK5CYII="};
